import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../../store/actions';
import * as TYPES from '../../store/actions/actions.js';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import Moment from 'react-moment';
import './style.sass';
import { useNavigate } from 'react-router-dom';
import { nthNumber } from '../../common';
import beec_logo from '../../assets/img/beec_logo.png';

function PrintPdf() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [quizId, setQuizId] = useState('');
  const [quizFinish, setQuizFinish] = useState({});
  const [subScores, setSubScores] = useState([]);
  const [isSubscoreIsAnalysisInScience, setIsSubscoreIsAnalysisInScience] = useState(false);
  const [isSubscoreIsAnalysisInHistory, setIsSubscoreIsAnalysisInHistory] = useState(false);
  const [indexOfSubscore, setIndexOfSubscore] = useState(0);
  const [userAnswers, setUserAnswers] = useState([]);
  const [quizFinishedState, quizFinishedId] = useSelector((state) => {
    return [state.finishUserQuiz.quizFinishedData, state.finishUserQuiz.quizFinishedId];
  });

  useEffect(() => {
    if (quizFinishedState) {
      if (quizFinishedState?.subScores) {
        const temp = [];
        quizFinishedState.subScores.map((subScore, index) => {
          const parsed = JSON.parse(subScore);
          console.log('Parsed subScore:', parsed); // Debug output
          if (parsed?.title === 'Analysis in Science') {
            setIsSubscoreIsAnalysisInScience(true);
            setIndexOfSubscore(index);
          }
          if (parsed?.title === 'Analysis in History/Social Studies') {
            setIsSubscoreIsAnalysisInHistory(true);
            setIndexOfSubscore(index);
          }
          if (parsed.correct !== undefined && parsed.count > 0) {
            const ratio = parsed.correct / parsed.count;
            parsed.calculatedConverted = Math.max(1, Math.min(15, Math.round(ratio * 15)));
            console.log(
              `Recalculated ${parsed.title}: ${parsed.calculatedConverted} (from ${parsed.correct}/${parsed.count})`,
            );
          } else {
            parsed.calculatedConverted = parsed.converted || 1;
            console.log(`Fallback ${parsed.title}: ${parsed.calculatedConverted}`);
          }
          temp.push(parsed);
        });
        setSubScores(temp);
      }

      if (quizFinishedState?.userAnswer) {
        const temp = [];
        quizFinishedState.userAnswer.map((userAnswer, index) => {
          temp.push(JSON.parse(userAnswer));
        });
        setUserAnswers(temp);
      }
      setQuizFinish(quizFinishedState);
    }
    dispatch({ type: TYPES.UI_START_LOADING });
  }, [quizFinishedState]);

  useEffect(() => {
    if (quizFinishedId) {
      setQuizId(quizFinishedId);
    }
    dispatch({ type: TYPES.UI_START_LOADING });
  }, [quizFinishedId]);

  useEffect(() => {
    const fetchData = async () => {
      const element = document.getElementById('printPDF');
      const opt = {
        margin: 0.5,
        filename: 'score-report.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 5, useCORS: true, backgroundColor: '#ffffff' },
        jsPDF: { unit: 'cm', format: 'a4', orientation: 'portrait' },
        pagebreak: {
          mode: ['avoid-all', 'css', 'legacy'],
          before: '.page-break-before-section',
          after: '.page-break-after',
          avoid: [
            '.total-score-div',
            '.section-score-div',
            '.sub-score-div',
            '.profile-detail-div',
            '.response-item',
            '.response-table tr',
            '.cross-test-category',
            '.category-header',
            '.skill-group-header',
            '.skill-analysis tr',
          ],
        },
      };
      html2pdf().from(element).set(opt).save();
      setTimeout(() => {
        dispatch({
          type: TYPES.LOADER_TEXT,
          data: '',
        });
        navigate('/dashboard');
      }, 1000);
    };
    if (quizId !== '') {
      dispatch(Actions.dispatchGetQuizScores(quizId)).then(() => {
        setTimeout(() => {
          fetchData().catch(console.error);
        }, 500);
      });
    }
    dispatch({ type: TYPES.UI_START_LOADING });
  }, [quizId]);

  function RenderAnswer(actualAnswer) {
    try {
      var answer = JSON.parse(actualAnswer);
      var text = '';
      switch (answer[0]) {
        case 'MATCH':
          for (var i = 1; i < answer.length; i++) {
            if (i === 1) {
              text += answer[i];
            } else {
              text += ' OR ' + answer[i];
            }
          }
          break;
        case 'RANGE':
          text = 'Answer should be between ' + answer[1] + ' - ' + answer[2];
          break;
        default:
          break;
      }
      return text;
    } catch (err) {
      console.log('CheckSPRAnswer failed catch');
      return false;
    }
  }

  const hasCrossTestCategory =
    isSubscoreIsAnalysisInScience || isSubscoreIsAnalysisInHistory;

  const isMathSection = (title) => /math/i.test(title || '');

  return (
    <React.Fragment>
      <div className="print_hidden">
        <div id="printPDF" className="container-fluid print_pdf_page">
          <div className="row">
            <div className="col-md-12">
              <div className="total-score-div">
                <p className="heading">Your total score</p>
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="total-score">{quizFinish?.score?.converted}</div>
                    <div className="score-range">
                      400-
                      <br />
                      1600
                    </div>
                  </div>
                  <img className="report-logo" src={beec_logo} alt="beec-logo" />
                </div>
              </div>
              <div className="section-score-div">
                <p className="heading">Section Scores</p>
                {quizFinish?.score?.sections?.map((section) => {
                  return (
                    <>
                      {section?.type === 'SECTION' && (
                        <div className="row">
                          <div className="col-4">
                            <div className="d-flex align-items-center">
                              <div className="small-score">{section?.converted}</div>
                              <div className="small-score-range">200-800</div>
                            </div>
                            <div className="small-score-desc">Your {section?.title} score</div>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              </div>

              <div className="sub-score-div">
                <p className="heading">
                  SubScores <span className="sub-heading">1-15</span>
                </p>
                <div className="row">
                  {subScores
                    ?.filter((subScore) => subScore.count >= 5 && subScore.tagType === 'SUBSCORE')
                    .map((subScore) => {
                      return (
                        <div className="col-3 mt-3">
                          <div className="d-flex align-items-center">
                            <div className="small-score">{subScore.calculatedConverted}</div>
                          </div>
                          <div className="small-score-desc">{subScore?.title}</div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="profile-detail-div">
                <div className="profile-item">
                  <p className="label">Student Name</p>
                  <p className="value">
                    {quizFinish?.user?.firstName} {quizFinish?.user?.lastName}
                  </p>
                </div>
                <div className="profile-item">
                  <p className="label">Test Date</p>
                  <p className="value">
                    <Moment format="MMM DD, YYYY">{quizFinish?.startedAt}</Moment>
                  </p>
                </div>
                <div className="profile-item">
                  <p className="label">Test Name</p>
                  <p className="value">
                    {quizFinish?.quiz?.alias ? quizFinish?.quiz?.alias : quizFinish?.quiz?.title}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="student-response-div">
            <div className="heading">Student Responses and Correct Answers</div>
            <div className="row">
              {quizFinish?.score?.sections?.map((section) => {
                return (
                  <>
                    {section?.type === 'TEST' && (
                      <>
                        {userAnswers
                          .filter((x) => x.sectionId === section?.id)
                          .sort((a, b) => a.orderId - b.orderId).length > 0 && (
                          <div className="col-3">
                            <div className="response-item">
                              <p>{section?.title}</p>
                              <table className="response-table">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th className="th-bold">Std</th>
                                    <th className="th-italic">Cor</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {userAnswers
                                    .filter((x) => x.sectionId === section?.id)
                                    .sort((a, b) => a.orderId - b.orderId)
                                    ?.map((section, index) => {
                                      return (
                                        <tr>
                                          <td>{section?.orderId}</td>
                                          <td>{section?.answer?.toUpperCase()}</td>
                                          <td>
                                            {section?.correct === 'TRUE'
                                              ? '✓'
                                              : section?.correctAnswer?.includes('MATCH' || 'RANGE')
                                              ? RenderAnswer(section?.correctAnswer)
                                              : section?.correctAnswer?.toUpperCase()}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                );
              })}
            </div>
          </div>

          {hasCrossTestCategory && (
            <div className="cross-test-category">
              <table className="cross-category-table table border-light">
                <thead>
                  <tr>
                    <th>Cross-Test Categories</th>
                    <th>Correct</th>
                    <th>Correct</th>
                    <th>Incorrect</th>
                    <th>Omitted</th>
                    <th>Incorrect and Omitted Questions</th>
                  </tr>
                </thead>
                <tbody>
                  {isSubscoreIsAnalysisInScience && (
                    <tr>
                      <td>Analysis in History/Social Studies</td>
                      <td>
                        {(
                          (JSON.parse(quizFinish?.subScores[indexOfSubscore])?.correct /
                            JSON.parse(quizFinish?.subScores[indexOfSubscore])?.count) *
                          100
                        ).toFixed(0)}
                        %
                      </td>
                      <td>{JSON.parse(quizFinish?.subScores[indexOfSubscore])?.correct}</td>
                      <td>{JSON.parse(quizFinish?.subScores[indexOfSubscore])?.incorrects.length}</td>
                      <td>{JSON.parse(quizFinish?.subScores[indexOfSubscore])?.skip}</td>
                      <td>
                        {JSON.parse(quizFinish?.subScores[indexOfSubscore])
                          ?.incorrects?.sort((a, b) => a - b)
                          ?.map((item) => (
                            <>{item}, </>
                          ))}
                      </td>
                    </tr>
                  )}
                  {isSubscoreIsAnalysisInHistory && (
                    <tr>
                      <td>Analysis in Science</td>
                      <td>{JSON.parse(quizFinish?.subScores[indexOfSubscore])?.correct}%</td>
                      <td>{JSON.parse(quizFinish?.subScores[indexOfSubscore])?.correct}</td>
                      <td>{JSON.parse(quizFinish?.subScores[indexOfSubscore])?.incorrects.length}</td>
                      <td>{JSON.parse(quizFinish?.subScores[indexOfSubscore])?.skip}</td>
                      <td>
                        {JSON.parse(quizFinish?.subScores[indexOfSubscore])
                          ?.incorrects?.sort((a, b) => a - b)
                          ?.map((item) => (
                            <>{item}, </>
                          ))}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          <div className="skill-analysis">
            <table className="skill-analysis-table">
              <thead>
                <tr>
                  <th>Skill Analysis</th>
                  <th>Correct</th>
                  <th>Correct</th>
                  <th>Incorrect</th>
                  <th>Omitted</th>
                  <th>Incorrect and Omitted Questions</th>
                </tr>
              </thead>
              <tbody>
                {quizFinish?.score?.sections?.map((section, index) => {
                  return (
                    <>
                      {section?.type === 'TEST' && section?.tags && (
                        <>
                          <tr
                            className={`text-bolder category-header${
                              isMathSection(section?.title) ? ' page-break-before-section' : ''
                            }`}
                          >
                            <td colSpan="6" className="text-bolder">{section?.title}</td>
                          </tr>
                          {section?.tags?.map((item, index) => {
                            return (
                              <>
                                <tr className="skill-group-header">
                                  <td colSpan="6" className="bg-gray">
                                    {item?.title}
                                  </td>
                                </tr>
                                {item?.decendants?.map((subSection, subSectionIndex) => {
                                  return (
                                    <tr>
                                      <td>{subSection?.title}</td>
                                      <td>
                                        {((subSection?.correct / subSection?.count) * 100).toFixed(
                                          0,
                                        )}
                                        %
                                      </td>
                                      <td>{subSection?.correct}</td>
                                      <td>{subSection?.count - subSection?.correct}</td>
                                      <td>{subSection?.skip}</td>
                                      <td>
                                        {subSection?.incorrects
                                          ?.slice()
                                          ?.sort((a, b) => {
                                            const aVal = typeof a === 'object' ? a.orderId : a;
                                            const bVal = typeof b === 'object' ? b.orderId : b;
                                            return aVal - bVal;
                                          })
                                          ?.map((subScore, idx) => {
                                            const val = typeof subScore === 'object' ? subScore.orderId : subScore;
                                            return <span key={idx}>{val}, </span>;
                                          })}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </>
                            );
                          })}
                        </>
                      )}
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default PrintPdf;
